import { render, staticRenderFns } from "./VueErrorsCover.vue?vue&type=template&id=3c5c4d8e&"
import script from "./VueErrorsCover.vue?vue&type=script&lang=js&"
export * from "./VueErrorsCover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports